import React, { useEffect, useState } from 'react';
import { Oval } from 'react-loader-spinner';
import { useTranslation } from 'react-i18next';
import BackButton from '../common/backButton';
import moment from 'moment';
import { getDataWithToken, postDataWithToken } from '../api/api';
import { ALL_SESSION_HISTORY, BMIPROGRESSION, GETGAMES, IMAGE_API_URL } from '../helpers/Constant';
import { getUserStreak } from '../utils/common';
import SessionHistory from '../common/SessionHistory';
import { useNavigate } from 'react-router-dom';
import Loader from '../common/loader';

function DailyTarget() {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [today, setToday] = useState(0);
    const [loading, setLoading] = useState(true);
    const [weekDates, setWeekDates] = useState([]);
    const [selectedDate, setSelectedDate] = useState(moment());
    const [weekOffset, setWeekOffset] = useState(0);
    const [noOfSessions, setNoOfSessions] = useState(0);
    const [streak, setStreak] = useState(0);
    const [timelineEvents, setTimelineEvents] = useState([]);
    const [ShowSessionModal, setShowSessionModal] = useState(false);
    const [sessionId, setSessionId] = useState('');
    const [gamesData, setGamesData] = useState([]);


    const showSessionHistory = (event) => {
        setShowSessionModal(true);
        setSessionId(event.sessionId);
    }

    const fetchData = async (dateForRequest = selectedDate) => {
        var userStreak = getUserStreak();
        if(selectedDate && !selectedDate.isSame(moment(), 'day')){
            userStreak = 0;
        }

        setToday(0);
        setTimelineEvents([]);
        setNoOfSessions(0);

        const startDate = selectedDate.format('YYYY-MM-DD');
        const sessionHistoryUrl = `${ALL_SESSION_HISTORY}?startDate=${startDate}`;
        const sessionsGameData = await getDataWithToken(sessionHistoryUrl);

        if (sessionsGameData && sessionsGameData.length > 0) {
            setNoOfSessions(sessionsGameData.length);

            var  sessionsByDate = {};
            sessionsGameData.forEach(session => {
                const sessionDate = moment(session.createdAt).format('YYYY-MM-DD');
                if (!sessionsByDate[sessionDate]) {
                    sessionsByDate[sessionDate] = [];
                }
                sessionsByDate[sessionDate].push(session);
            });
            
            const key = selectedDate.format('YYYY-MM-DD');
            const events = sessionsByDate[key] || [];
            
            var totalBurnedCal = 0;
            events.forEach(event => {
                totalBurnedCal += event.histories.reduce((sum, h) => sum + (Number(h.burnedCal) || 0), 0);
            });
            setToday(totalBurnedCal);
            setTimelineEvents(events);
            setNoOfSessions(events.length);
            setStreak(events[0]?.userStreak || userStreak);
        }else{
            setStreak(userStreak);
        }
        setLoading(false);
    }

    useEffect(() => {
        const startOfWeek = moment().startOf('week').add(weekOffset, 'weeks');
        const days = Array.from({ length: 7 }, (_, index) =>
            startOfWeek.clone().add(index, 'day')
        );
        setWeekDates(days);

        if (weekOffset === 0) {
            fetchData();
        }
    }, [weekOffset]);

    const changeWeek = (direction) => {
        if (direction === 'next' && weekOffset >= 0) return;
        setWeekOffset((prev) => prev + (direction === 'next' ? 1 : -1));
    };

    // Update data and timeline whenever selected date changes
    useEffect(() => {
        // Refresh KPI data for the newly selected date
        fetchData(selectedDate);
        fetchGamesData();
    }, [selectedDate]);

    const backButtonFunction = () => {
        if(ShowSessionModal) {
            setShowSessionModal(false);
        } else {
            navigate(-1);
        }
    }

    const fetchGamesData = async () => {
        const response = await getDataWithToken(GETGAMES);
        setGamesData(response);
    }

    const getGameImage = (gameName) => {
        if(!gamesData) return '';
        const game = gamesData.find(game => game.title === gameName);
        return game ? `${IMAGE_API_URL}${game.image}` : '';
    }


    return (
        <>
            <div className='wrapper h-100 px-0 pb-0'>
                {loading && <Loader />}
                
                <div className="px-3">
                    <BackButton label={t('Home')} closeFunction={backButtonFunction} />
                </div>

                <div className='calorie_section_wrapper p-12 mt-1 rounded-0'>
                    <h6 className='mb-3 text-white opacity-75 fw-bold'>{t('Overall calories burn')}</h6>
                    <div className='calorie_section row position-relative text-center'>
                        <div className='col-4'>
                            <h6 className='text-light mb-0'>{selectedDate.isSame(moment(), 'day') ? t('Today') : selectedDate.format('DD MMM')}</h6>
                            <span className='text-white pt-2 pb-3 fw-bold d-flex align-items-center justify-content-center gap-2 position-relative'>
                                <img src='../images/fireicon.svg' height={20} alt='fireicon' />
                                {today}
                            </span>
                        </div>
                        <div className='col-4 position-relative'>
                            <h6 className='text-light mb-0'>{t('No. of Sessions')}</h6>
                            <span className='text-white pt-2 pb-3 fw-bold d-flex align-items-center justify-content-center gap-2 position-relative'>
                                {noOfSessions}
                            </span>
                        </div>
                        <div className='col-4 position-relative'>
                            <h6 className='text-light mb-0'>{t('Streak')}</h6>
                            <span className='text-white pt-2 pb-3 fw-bold d-flex align-items-center justify-content-center gap-2 position-relative'>
                                {streak}
                            </span>
                        </div>
                    </div>
                </div>

                {/* Weekly circular calendar */}
                <div className='weekly_section p-2'>
                    <div className='d-flex justify-content-between align-items-center mb-3'>
                        <button
                            className='btn btn-sm p-0 text-white opacity-75'
                            onClick={() => changeWeek('prev')}
                            style={{ background: 'transparent', border: 'none', fontSize: 20 }}
                        >
                            &#8249;
                        </button>
                        <h6 className='mb-0 text-white opacity-75 fw-normal'>
                            {weekDates.length > 0 ? weekDates[0].format('MMMM - YYYY') : selectedDate.format('MMMM - YYYY')}
                        </h6>
                        <button
                            className='btn btn-sm p-0 text-white'
                            onClick={() => changeWeek('next')}
                            disabled={weekOffset >= 0}
                            style={{
                                background: 'transparent',
                                border: 'none',
                                fontSize: 20,
                                opacity: weekOffset >= 0 ? 0.3 : 0.75,
                                cursor: weekOffset >= 0 ? 'not-allowed' : 'pointer',
                            }}
                        >
                            &#8250;
                        </button>
                    </div>
                    <div className='d-flex justify-content-between'>
                        {weekDates.map((date) => {
                            const isToday = date.isSame(moment(), 'day');
                            const isPastOrToday = date.isSameOrBefore(moment(), 'day');
                            const isSelected = date.isSame(selectedDate, 'day');

                            const circleStyle = {
                                width: 36,
                                height: 36,
                                borderRadius: '50%',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                border: `2px solid ${isSelected || isToday ? '#DAFF00' : 'transparent'}`,
                                color: '#CDCDCD',
                                backgroundColor: 'rgba(255,255,255,0.05)',
                                boxShadow: isToday ? '0 0 8px rgba(218,255,0,0.7)' : 'none',
                                cursor: 'pointer',
                            };

                            const circleSmallStyle = {
                                width: 15,
                                height: 15,
                                borderRadius: '50%',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                color: isPastOrToday && !isSelected ? '#FFFFFF' : isSelected ? '#000000' : '#64646A',
                                backgroundColor: isSelected ? '#DAFF00' : 'transparent',
                                fontSize: '10px',
                            };

                            return (
                                <div
                                    key={date.format('YYYY-MM-DD')}
                                    className={`d-flex flex-column align-items-center gap-2 ${isSelected ? 'date-selected' : ''}`}
                                    onClick={() => setSelectedDate(date)}
                                >
                                    <div className='fw-medium' style={circleStyle}>
                                        {date.format('D')}
                                    </div>
                                    <small style={circleSmallStyle}>
                                        {date.format('dd').charAt(0)}
                                    </small>
                                </div>
                            );
                        })}
                    </div>
                </div>

                {/* Timeline for selected date - continuous axis, events positioned by start/end */}
                <div className='timeline_section py-1'>
                    <div className='daily_timeline d-flex gap-2'>
                        <div
                            className='daily_timeline_left flex-shrink-0 daily_timeline_heading py-1 text-white opacity-75 px-2 text-center'
                            style={{ width: 56 }}
                        >
                            {(() => {
                                try {
                                    const shortParts = Intl.DateTimeFormat(undefined, { timeZoneName: 'short' }).formatToParts(new Date());
                                    const shortTz = shortParts.find((p) => p.type === 'timeZoneName')?.value || '';
                                    const isOffset = /[+-]\d{1,2}(:\d{2})?$|^GMT[+-]|^UTC[+-]/i.test(shortTz.trim());
                                    if (isOffset) {
                                        const longParts = Intl.DateTimeFormat(undefined, { timeZoneName: 'long' }).formatToParts(new Date());
                                        const longTz = longParts.find((p) => p.type === 'timeZoneName')?.value;
                                        return longTz || shortTz;
                                    }
                                    return shortTz || Intl.DateTimeFormat().resolvedOptions().timeZone;
                                } catch {
                                    return t('IST1');
                                }
                            })()}
                        </div>
                        <div
                            className='daily_timeline_right border-start flex-grow-1 daily_timeline_heading py-1 text-white opacity-75 px-2'
                        >
                            {selectedDate.format('MMM')}
                            <br />
                            <span>{selectedDate.format('DD')}</span>
                        </div>
                    </div>

                    {(() => {
                        const PIXELS_PER_HOUR = 60;
                        const HOURS_BEFORE_FIRST_SESSION = 2;
                        const dayStartMidnight = selectedDate.clone().startOf('day');

                        // Start time max: 2 hours before first session (or start of day if no sessions)
                        let viewStart = dayStartMidnight.clone();
                        if (timelineEvents.length > 0) {
                            const earliestCreatedAt = timelineEvents.reduce(
                                (earliest, e) => moment(e.createdAt).isBefore(moment(earliest)) ? e.createdAt : earliest,
                                timelineEvents[0].createdAt
                            );
                            const firstSessionStart = moment(earliestCreatedAt);
                            const maxStartBeforeFirst = firstSessionStart.clone().subtract(HOURS_BEFORE_FIRST_SESSION, 'hours');
                            if (maxStartBeforeFirst.isAfter(dayStartMidnight) || maxStartBeforeFirst.isSame(dayStartMidnight)) {
                                viewStart = maxStartBeforeFirst;
                            }
                        }

                        const dayEnd = selectedDate.clone().endOf('day');
                        const totalMinutes = dayEnd.diff(viewStart, 'minutes');
                        const TOTAL_HOURS = Math.max(1, totalMinutes / 60);

                        const MIN_SESSION_HEIGHT = 44;
                        const hourLabels = [];
                        for (let i = 0; i <= Math.ceil(TOTAL_HOURS); i++) {
                            const labelTime = viewStart.clone().add(i, 'hours');
                            if (labelTime.isAfter(dayEnd)) break;
                            hourLabels.push({ index: i, moment: labelTime, sessionMinutes: 0, sessionCount: 0, heightPx: PIXELS_PER_HOUR });
                        }

                        if (timelineEvents.length > 0) {
                            timelineEvents.forEach(event => {
                                const startM = moment(event.createdAt);
                                const startHour = startM.hour();
                                const hasCompletedAt = event.completedAt != null && event.completedAt !== '';
                                const endM = hasCompletedAt ? moment(event.completedAt) : startM.clone().add(1, 'hour');
                                const endHour = endM.hour();

                                const totalDiffInMinutes = endM.diff(startM, 'minutes');
                                
                                hourLabels.forEach(hourLabel => {
                                    const labelHour = hourLabel.moment.hour();
                                    
                                    if (labelHour >= startHour && labelHour <= endHour) {
                                        let minutesToAdd = 0;
                                        let sessionCount = 0;
                                        
                                        if (startHour === endHour) {
                                            // Same hour: add full duration
                                            minutesToAdd = totalDiffInMinutes;
                                            sessionCount = 1;
                                        } else if (labelHour === startHour) {
                                            // First hour: minutes remaining to complete this hour (60 - startMinute)
                                            minutesToAdd = 60 - startM.minute();
                                            sessionCount = (minutesToAdd / 60).toFixed(2);
                                        } else if (labelHour === endHour) {
                                            // Last hour: minutes from start of hour to end time
                                            minutesToAdd = endM.minute();
                                            sessionCount = (minutesToAdd / 60).toFixed(2);
                                        } else {
                                            // Middle hours: full 60 minutes
                                            minutesToAdd = 60;
                                            sessionCount = 1;
                                        }
                                        
                                        hourLabel.sessionMinutes += minutesToAdd;
                                        hourLabel.sessionCount += parseFloat(sessionCount);
                                    }
                                });
                            });
                        }

                        // Calculate heightPx and top for each hour based on session count
                        let cumulativeTop = 0;
                        hourLabels.forEach(hourLabel => {
                            const requiredHeight = hourLabel.sessionCount * MIN_SESSION_HEIGHT;
                            hourLabel.heightPx = Math.max(PIXELS_PER_HOUR, requiredHeight);
                            hourLabel.top = cumulativeTop;
                            cumulativeTop += hourLabel.heightPx;
                        });

                        // Total timeline height is sum of all hour heights
                        const timelineHeight = cumulativeTop;

                        return (
                            <div
                                className='daily_timeline d-flex gap-2'
                                style={{ minHeight: timelineHeight }}
                            >
                                {/* Left: hour labels at correct vertical positions */}
                                <div
                                    className='daily_timeline_left position-relative flex-shrink-0'
                                    style={{ width: 56 }}
                                >
                                    {hourLabels.map(({ index: hour, moment: labelM, top }) => (
                                        <div
                                            key={hour}
                                            className='text-end text-white small position-absolute'
                                            style={{
                                                top: top - 6,
                                                right: 0,
                                                fontSize: 12,
                                                lineHeight: 1,
                                                opacity: 0.6,
                                            }}
                                        >
                                            {labelM.format('h A')}
                                        </div>
                                    ))}
                                </div>
                                {/* Right: event blocks positioned by start/end time */}
                                {timelineEvents.length > 0 && (
                                    <div
                                        className='daily_timeline_right border-start flex-grow-1 position-relative'
                                        style={{ minHeight: timelineHeight }}
                                    >
                                        <div
                                            className='position-absolute w-100'
                                        >
                                            {hourLabels.map(({ index: hour, top }) => (
                                                <div
                                                    key={hour}
                                                    className='daily_timeline_divider position-absolute border-top w-100'
                                                    style={{
                                                        top: top,
                                                        right: 0,
                                                        fontSize: 12,
                                                        lineHeight: 1,
                                                        opacity: 0.6,
                                                    }}
                                                >
                                                </div>
                                            ))}
                                        </div>
                                        
                                        {hourLabels.map((hourLabel) => {
                                            const labelHour = hourLabel.moment.hour();
                                            // Find events that start in this hour
                                            const eventsInHour = timelineEvents.filter(event => {
                                                const startHour = moment(event.createdAt).hour();
                                                return startHour === labelHour;
                                            });

                                            let eventOffsetInHour = 0;
                                            return eventsInHour.map((event, eventIndex) => {
                                                const startM = moment(event.createdAt);
                                                const hasCompletedAt = event.completedAt != null && event.completedAt !== '';
                                                const endM = hasCompletedAt ? moment(event.completedAt) : startM.clone().add(1, 'hour');
                                                let durationMinutes = endM.diff(startM, 'minutes');
                                                if (!hasCompletedAt) durationMinutes = 60;
                                                else if (durationMinutes > 4 * 60) durationMinutes = 3 * 60;
                                                durationMinutes = Math.max(1, durationMinutes);

                                                const topPx = hourLabel.top + eventOffsetInHour;
                                                const heightPx = Math.max(MIN_SESSION_HEIGHT, (durationMinutes / 60) * PIXELS_PER_HOUR);
                                                eventOffsetInHour += MIN_SESSION_HEIGHT;

                                                return event.histories && event.histories.length > 0 ? (
                                                    <div
                                                        key={event.id}
                                                        className='position-absolute start-0 end-0 d-flex align-items-center overflow-hidden'
                                                        onClick={() => showSessionHistory(event)}
                                                        style={{
                                                            top: topPx,
                                                            height: heightPx,
                                                            backgroundColor: `${eventIndex % 2 === 0 ? '#22638D' : '#A23828'}`,
                                                            borderLeft: `5px solid ${eventIndex % 2 === 0 ? '#3197DA' : '#F85739'}`,
                                                            borderRadius: '6px 0 0 6px',
                                                            padding: '10px',
                                                            minHeight: MIN_SESSION_HEIGHT,
                                                        }}
                                                    >
                                                        <div className='d-flex align-items-center text-white fw-bold'>
                                                            <div className='event-histories-games d-flex align-items-center gap-1'>
                                                                {event.histories && (
                                                                    event.histories.slice(0, 5).map((history) => (
                                                                        history.gameName && getGameImage(history.gameName) !== '' && (
                                                                            <img
                                                                                src={getGameImage(history.gameName)}
                                                                                width={20}
                                                                                height={20}
                                                                                alt='game'
                                                                                className='bg-white border border-white rounded'
                                                                            />
                                                                        )
                                                                    ))
                                                                )}
                                                            </div>
                                                            <img
                                                                src='../images/fireicon.svg'
                                                                height={18}
                                                                alt='fire'
                                                                className='me-1 flex-shrink-0'
                                                            />
                                                            {event.histories.reduce((sum, h) => sum + (Number(h.burnedCal) || 0), 0)}{' '}
                                                            <small className='fw-normal opacity-75 ms-1'>kcal</small>
                                                        </div>
                                                    </div>
                                                ) : null ;
                                            });
                                        })}
                                    </div>
                                )}
                            </div>
                        );
                    })()}
                </div>
            </div >
            {ShowSessionModal && sessionId !== '' ? <SessionHistory showSessionHistoryModal={ShowSessionModal} sessionId={sessionId} closeSessionHistoryModal={() => setShowSessionModal(false)} gamesData={gamesData} showDailyTarget={false} /> : ''}
        </>
    )
}

export default DailyTarget